import { render, staticRenderFns } from "./CollaboratorsWith.vue?vue&type=template&id=d4a3a44a&scoped=true"
import script from "./CollaboratorsWith.vue?vue&type=script&lang=js"
export * from "./CollaboratorsWith.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorsWith.vue?vue&type=style&index=0&id=d4a3a44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a3a44a",
  null
  
)

export default component.exports